mutation DeletePeepMap($input: PeepMapDeleteInput!) {
    peepMapDelete(input: $input) {
        success
    }
}
